import { apiManager } from "./apiManager";

export const deliveryPageApi = {
  getDeliveryPageData: async (id) => await apiManager.get(`/dashboard/tour-data/${id}`),
}